// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"d8e848ac","172":"d96a73a3","203":"ebedc7c5","372":"054fc2c9","407":"1a48efc3","464":"e52a7c64","483":"951af192"}[chunkId] + ".chunk.js";
};